import { Routes } from '@angular/router';
import { SOFTLINE_PERMISSION_WWS_UMSATZSTATISTIK } from '@softapps/wws/umsatzstatistik';
import { AuthenticationGuard } from '@softline/auth';
import { AbortableApiDataAccess, ApiDataAccess } from '@softline/core';
import { DocumentTypesRepository } from './repositories/document-types.repository';
import { StatisticTypesRepository } from './repositories/statistic-types.repository';
import { SalesOrganisationChartService } from './services/sales-organisation-chart.service';
import { DocumentTypesService } from './services/document-types.service';
import { CustomerDrillChartService } from './services/customer-drill-chart.service';
import { RevenueTrendChartService } from './services/revenue-trend-chart.service';
import { ProductDrillChartService } from './services/product-drill-chart.service';
import { SalesStatisticsGridCacheService } from './services/sales-statistics-grid-cache.service';
import { SalesStatisticsLoadingService } from './services/sales-statistics-loading.service';
import { SalesStatisticsQueryService } from './services/sales-statistics-query.service';
import { StatisticTypesService } from './services/statistic-types.service';
import { TotalKpisService } from './services/total-kpis.service';
import { WarehouseInventoryChartService } from './services/warehouse-inventory-chart.service';

export const salesStatisticsRoutes: Routes = [
  {
    path: 'sales-statistics',
    loadComponent: () => import('./pages/sales-statistics.page'),
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./pages/dashboard/dashboard.page').then((o) => o.DashboardPage),
      },
      {
        path: 'table',
        loadComponent: () => import('./pages/table/table.page').then((o) => o.TablePage),
      },
      {
        path: '**',
        redirectTo: '/sales-statistics/dashboard',
      },
    ],
    providers: [
      { provide: ApiDataAccess, useClass: AbortableApiDataAccess },
      AbortableApiDataAccess,
      SalesStatisticsQueryService,
      SalesStatisticsLoadingService,
      SalesStatisticsGridCacheService,
      DocumentTypesRepository,
      DocumentTypesService,
      StatisticTypesRepository,
      StatisticTypesService,
      TotalKpisService,
      SalesOrganisationChartService,
      CustomerDrillChartService,
      ProductDrillChartService,
      RevenueTrendChartService,
      WarehouseInventoryChartService,
    ],
    canActivate: [AuthenticationGuard],
    data: { permission: SOFTLINE_PERMISSION_WWS_UMSATZSTATISTIK },
  },
];
